// React
import React, { Component } from "react";
import { connect } from "react-redux";
// Routing
import { withRouter } from "react-router-dom";
// Infrastructure
import { UsersAPI } from "views/Users/infrastructure";
// Components
import CardList from "components/Cards/cardList";
// Translations
import { withTranslation } from "react-i18next";
// Amplitude API
import { AmplitudeAPI } from "@api/Amplitude";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      array: []
    };
  }

  componentDidMount() {
    this.getUsers();
  }

  // get users data
  getUsers = async () => {
    const { access, user } = this.props.data;
    try {
      const obj = new UsersAPI(access.userId, access, this.props, user);
      let res = await obj.get_account_users(user.account_id);
      this.setState({ array: res });
    } catch (err) {}
  };

  editElement = (e, id) => {
    e.preventDefault();
    const { history } = this.props;
    history.push(`${history.location.pathname}/edit/${id}`);
  };

  handleClickOpen = () => {
    const { user, device_id } = this.props.data;
    const { history } = this.props;
    new AmplitudeAPI({
      event_type: "Click on create user",
      device_id: device_id,
      user_id: user.email
    }).eventLog();

    history.push(`${history.location.pathname}/create`);
  };

  render() {
    const { array } = this.state;
    return (
      array &&
      array.length > 0 && (
        <CardList
          data={this.props.data}
          t={this.props.t}
          handleClickOpen={this.handleClickOpen}
          history={this.props.history}
          list={array}
          open={false}
        />
      )
    );
  }
}

const mapStateToProps = (state) => {
  return {
    data: state
  };
};

const connect_users = connect(mapStateToProps)(Users);

export default withTranslation("users")(withRouter(connect_users));
